import {useEffect} from 'react';
import useSession from './hooks/user/useSession';
import useAlert from './hooks/alert/useAlert';
import Routing from './route/Routing';
import AppLayout from './layouts/AppLayout';
import useIdleLogout from './hooks/timeout/useIdleLogout';

export default function App() {
  const session = useSession();
  const alert = useAlert();

  useIdleLogout(session.logout);

  useEffect(() => {
    if (localStorage.getItem('loggedOutDueToInactivity') === 'true') {
      alert.info('You have been logged out due to inactivity.');
      localStorage.removeItem('loggedOutDueToInactivity');
    }
  }, []);

  return (
    <AppLayout>
      <Routing/>
    </AppLayout>
  )
};
